import React from "react";


interface ProposalKeyDistancesCardDetailsProps {
    propertyData: any;
}


export default function ProposalKeyDistancesCardDetails({ propertyData }: ProposalKeyDistancesCardDetailsProps) {
    return (
        <>
            {propertyData?.nearestPlaces?.length ? (
                <table
                    width="100%"
                    cellPadding="0"
                    cellSpacing="0"
                    style={{ fontSize: "15px" }}
                >
                    <tr>
                        <td height="35"></td>
                    </tr>
                    <tr>
                        <td
                            colSpan={2}
                            style={{
                                fontSize: "15px",
                                fontWeight: 700,
                            }}
                        >
                            <u>KEY DISTANCES:</u>
                        </td>
                    </tr>

                    <tr>
                        <td height="12"></td>
                    </tr>
                    <tr>
                        <td width="50%">
                            <table
                                width="100%"
                                cellPadding="0"
                                cellSpacing="0"
                            >
                                <tbody>
                                    <tr>
                                        <td
                                            style={{
                                                color: "#5E5E5E",
                                            }}
                                        >
                                            <ul className="row list-unstyled">
                                                {propertyData?.nearestPlaces?.map(
                                                    (nearby: {
                                                        attrName: string;
                                                        attrOptionValue: string;
                                                    }) => (

                                                        <li className="col-md-6 mb-2">
                                                            {nearby.attrName} : {nearby.attrOptionValue}{" "}
                                                        </li>

                                                    )
                                                )}
                                            </ul>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td height="6"></td>
                                    </tr>
                                </tbody>
                            </table>
                        </td>
                    </tr>
                    <tr>
                        <td colSpan={2} height="16"></td>
                    </tr>
                    <tr>
                        <td
                            colSpan={2}
                            style={{
                                height: "3px",
                                backgroundColor: "#C39864",
                            }}
                        ></td>
                    </tr>
                </table>
            ) : null}
        </>
    );
}
